export function toCamelCase(str: string): string {
  return str.replace(/_([a-z])/g, (_: string, letter: string) => letter.toUpperCase());
}

export function convertKeysToCamelCase(errors: Record<string, unknown>): Record<string, unknown> {
  return Object.keys(errors).reduce((acc: Record<string, unknown>, key: string) => {
    const camelCaseKey = toCamelCase(key);
    acc[camelCaseKey] = errors[key];
    return acc;
  }, {});
}
